import PageHero from "@/components/PageHero";
import SEO from "@/components/SEO";
import PortalCard from "@/components/PortalCard";
import Reveal from "@/components/Reveal";
import { VENTURES } from "@/data/ventures";

const Ventures = () => {
  return (
    <div data-testid="page-ventures">
      <SEO
        title="Our Brands"
        description="Four Worlds. One Origin. Each Gopi Gadhvi Group brand has its own identity, audience and purpose."
        path="/ventures"
      />
      <PageHero
        eyebrow="Our Brands"
        heading="Four Worlds. One Origin."
        intro="Each Gopi Gadhvi Group brand has its own identity, audience and purpose. Together, they form a connected ecosystem spanning the spaces people acquire, the environments they inhabit, the ideas they create and the inner worlds they transform."
      />

      <section className="relative page-shell pb-28 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {VENTURES.map((v, i) => (
          <Reveal key={v.slug} delay={i * 90}>
            <PortalCard venture={v} />
          </Reveal>
        ))}
      </section>
    </div>
  );
};

export default Ventures;
